// src/pages/produccion/ConfigCapacidadMaxima.jsx
import { useEffect, useState } from 'react';
import api from '../../services/api';

export default function ConfigCapacidadMaxima() {
  const [filas, setFilas] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [guardandoLinea, setGuardandoLinea] = useState(null);
  const [mensaje, setMensaje] = useState(null);

  async function cargar() {
    try {
      setCargando(true);
      const res = await api.get('/api/produccion/config/capacidad-maxima');
      setFilas(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setCargando(false);
    }
  }

  useEffect(() => { cargar(); }, []);

  function handleCambiar(linea, valor) {
    setFilas((prev) => prev.map((f) => (f.linea === linea ? { ...f, capacidad_kg_semana: valor } : f)));
  }

  async function handleGuardar(linea) {
    const fila = filas.find((f) => f.linea === linea);
    try {
      setGuardandoLinea(linea);
      setMensaje(null);
      await api.put(`/api/produccion/config/capacidad-maxima/${encodeURIComponent(linea)}`, {
        capacidad_kg_semana: fila.capacidad_kg_semana,
      });
      setMensaje({ tipo: 'ok', texto: `✓ ${linea} actualizado.` });
    } catch (err) {
      console.error(err);
      setMensaje({ tipo: 'error', texto: `No se pudo guardar ${linea}.` });
    } finally {
      setGuardandoLinea(null);
    }
  }

  if (cargando) return <div style={styles.contenedor}>Cargando...</div>;

  return (
  <div style={styles.contenedor} className="contenedor-captura">
      <h1 style={styles.titulo}>Capacidad Máxima Semanal</h1>
      <p style={styles.subtitulo}>Usada para calcular Utilización de Capacidad — cámbiala cuando la capacidad real de la línea cambie.</p>

      {mensaje && <div style={{ ...styles.mensaje, color: mensaje.tipo === 'ok' ? '#3E7C5A' : '#B23A48' }}>{mensaje.texto}</div>}

      <div style={styles.tarjeta}>
        {filas.map((f) => (
          <div key={f.linea} style={styles.fila}>
            <div style={styles.lineaNombre}>{f.linea}</div>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <input
                type="number"
                step="0.01"
                value={f.capacidad_kg_semana}
                onChange={(e) => handleCambiar(f.linea, e.target.value)}
                style={styles.input}
              />
              <span style={styles.unidad}>kg / semana</span>
              <button onClick={() => handleGuardar(f.linea)} disabled={guardandoLinea === f.linea} style={styles.botonGuardar}>
                {guardandoLinea === f.linea ? '...' : 'Guardar'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  contenedor: { fontFamily: 'Inter, sans-serif', padding: '24px', color: '#3A2E42', maxWidth: '560px' },
  titulo: { fontFamily: 'Playfair Display, serif', color: '#2A1830', marginBottom: '4px' },
  subtitulo: { fontSize: '12px', color: '#8A7690', marginBottom: '18px' },
  mensaje: { fontSize: '13px', marginBottom: '14px', fontWeight: 600 },
  tarjeta: { background: '#fff', border: '1px solid #E6DDD2', borderRadius: '12px', padding: '18px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)', display: 'flex', flexDirection: 'column', gap: '14px' },
 fila: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '14px', paddingBottom: '14px', borderBottom: '1px solid #F0E9E0', flexWrap: 'wrap' },
  lineaNombre: { fontSize: '14px', fontWeight: 700, color: '#2A1830', minWidth: '80px' },
  input: { width: '110px', padding: '7px 10px', fontSize: '13px', border: '1px solid #D6A644', borderRadius: '6px', fontFamily: 'Inter, sans-serif', background: '#FFFDF7' },
  unidad: { fontSize: '11px', color: '#8A7690' },
  botonGuardar: { padding: '6px 14px', fontSize: '12px', fontWeight: 600, color: '#6E4F80', background: '#EFE9F3', border: '1px solid #A98BB8', borderRadius: '6px', cursor: 'pointer' },
};